import { combineReducers } from 'redux';

import resettingRequest from './request';
import resettingReset from './reset';

export default combineReducers({ resettingRequest, resettingReset });
